import { forwardRef } from 'react';
import { DesignSystem } from 'dragonmouse-shared/interfaces';
import * as S from './styles';

interface DsListItemProps {
	item: DesignSystem;
	onClick: () => void;
	highlighted?: boolean;
	onRowMouseEnter?: () => void;
}

const DsListItem = forwardRef<HTMLDivElement, DsListItemProps>(
	({ item, onClick, highlighted, onRowMouseEnter }, ref) => {
		const initial = (item.title?.[0] || 'D').toUpperCase();

		return (
			<S.Base
				ref={ref}
				onClick={onClick}
				onMouseEnter={onRowMouseEnter}
				selected={highlighted}
				title={item.title}
				data-testid="ds-picker-item"
			>
				<S.IconWrapper>{initial}</S.IconWrapper>
				<S.Content>
					<S.Name>{item.title}</S.Name>
				</S.Content>
			</S.Base>
		);
	}
);

DsListItem.displayName = 'DsListItem';

export default DsListItem;
